var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "5 4 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_19018",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469",
    transform: "translate(13519.5 -15909.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -13519.5, 15909.5)",
    filter: "url(#Rectangle_19018)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19018-2",
    "data-name": "Rectangle 19018",
    width: 20,
    height: 20,
    transform: "translate(10.5 8.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "notifications-none",
    transform: "translate(-13504.375 15921.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    d: "M43.764,12.975a1.3,1.3,0,0,0,1.3-1.3H42.466A1.3,1.3,0,0,0,43.764,12.975ZM47.98,9.082V5.516a4.174,4.174,0,0,0-3.243-4.087V.973a.973.973,0,1,0-1.946,0v.454a4.174,4.174,0,0,0-3.244,4.088V9.084l-1.3,1.3v.651H49.28V10.38Zm-1.3.649H40.845V5.516a2.919,2.919,0,1,1,5.838,0Z",
    transform: "translate(-38.25 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_988",
    "data-name": "Line 988",
    y1: 12.739,
    x2: 12.621,
    transform: "matrix(0.995, 0.105, -0.105, 0.995, -13504.393, 15921.734)",
    fill: "none",
    stroke: "#58667c",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_989",
    "data-name": "Line 989",
    y1: 12.739,
    x2: 12.622,
    transform: "matrix(0.995, 0.105, -0.105, 0.995, -13505.158, 15920.793)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellInactiveIcon);
export default __webpack_public_path__ + "static/media/bell_inactive_icon.d78e0021e4a05d47acb04d891d2a0046.svg";
export { ForwardRef as ReactComponent };